export default __webpack_public_path__ + "static/media/coin_eth.702d6e94.svg";